import { useState, useEffect} from "react";
function StateTimeIndicator({item, settings, className}) {
  const [day, setDay] = useState();
  const [month, setMonth] = useState();
  const [year, setYear] = useState();
  const [time, setTime] = useState();
  const [time24, setTime24] = useState();

  useEffect(()=>{
    if(item.startTime){
      const date = new Date(item.startTime);
      setDay(date.toLocaleDateString("en",{day: 'numeric'}));
      setMonth(date.toLocaleDateString("en",{month: 'short'}));
      setYear(date.toLocaleDateString("en",{year: 'numeric'}));
      setTime(date.toLocaleTimeString("en",{hour: '2-digit', minute:'2-digit', hourCycle: 'h12'}));
      setTime24(date.toLocaleTimeString("en",{hour: '2-digit', minute:'2-digit', hourCycle: 'h24'}));
    }
  },[]);

  const bgStyles = {
    na : '#000000',
    vod : '#068d0d',
    live : '#ff0036',
    scheduled : '#0c5bb6'
  }

  return(<>
    {((settings.states[item.state] || (settings.showTime && item.startTime))) &&
      <div className={`${className} text-[9px] md:text-[10px] lg:text-[1.25vw] xl:text-[.75vw] text-white px-2 py-1 select-none`}
      style={{backgroundColor: bgStyles[item.state]}}>
        {((!settings.showTime || !item.startTime) && settings.states[item.state]) && <span className="text-[1.2em] leading-[1.1em] uppercase">{settings.statesOverride[item.state] || item.state}</span>}
        {(settings.showTime && item.startTime) && 
          <div className="flex">
            <div className="flex flex-col justify-center items-center pr-2 mr-2 border-r border-r-white/50">
              <span className="text-[1.3em] leading-[1.2em]">{day}</span>
              <span className="text-[1em] leading-[0.9em]">{month}</span>
            </div>
            <div className="flex flex-col justify-center">
              <span className="text-[1.2em] leading-[1.1em]">{settings.timeFormat==='standard' ? time : time24}</span>
              {settings.states[item.state] && <span className="text-[1em] leading-[0.9em] uppercase">{settings.statesOverride[item.state] || item.state}</span>}
            </div>
          </div>
        }
      </div>
    }
    </>);
}
export default StateTimeIndicator;